import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { PublicRoute } from '@/components/routing';

// Lazy load auth pages
const Auth = lazy(() => import('@/pages/Auth'));
const LearnerAuth = lazy(() => import('@/pages/LearnerAuth'));
const AdminAuth = lazy(() => import('@/pages/AdminAuth'));
const IndividualRegistration = lazy(() => import('@/pages/IndividualRegistration'));
const CompanyRegistration = lazy(() => import('@/pages/CompanyRegistration'));
const Confirm = lazy(() => import('@/pages/auth/Confirm'));
const ConfirmationPending = lazy(() => import('@/pages/auth/ConfirmationPending'));
const AcceptInvitation = lazy(() => import('@/pages/AcceptInvitation'));
const InscriptionReprise = lazy(() => import('@/pages/InscriptionReprise'));
const SetupAccount = lazy(() => import('@/pages/SetupAccount'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function AuthRoutes() {
  return (
    <>
      <Route 
        path="/auth" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <Auth />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/learner" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <LearnerAuth />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/individual" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <IndividualRegistration />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/company" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <CompanyRegistration />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/admin" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <AdminAuth />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/confirm" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <Confirm />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/confirmation-pending" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <ConfirmationPending />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/auth/accept-invitation" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <AcceptInvitation />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/inscription/reprendre" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <InscriptionReprise />
            </Suspense>
          </PublicRoute>
        } 
      />
      <Route 
        path="/setup-account" 
        element={
          <PublicRoute>
            <Suspense fallback={<PageLoader />}>
              <SetupAccount />
            </Suspense>
          </PublicRoute>
        } 
      />
    </>
  );
}
